import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Subscriptions.css';

const Subscriptions = () => {
    const [userTier, setUserTier] = useState('');
    const [loading, setLoading] = useState(true);
    const [portalLoading, setPortalLoading] = useState(false);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_URL}/api/users/profile`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setUserTier(response.data.tier); // 'free', 'pro', or 'business'
            } catch (error) {
                console.error('Error fetching subscription profile:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [API_URL]);

    const handleManageBilling = async () => {
        setPortalLoading(true);
        try {
            const token = localStorage.getItem('token');
            // Request a secure Customer Portal link from your backend
            const response = await axios.post(`${API_URL}/api/stripe/customer-portal`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // Redirect the user directly to their hosted Stripe billing dashboard
            window.location.href = response.data.url;
        } catch (error) {
            console.error('Failed to open billing portal:', error);
            alert('Could not load billing portal. Please try again later.');
        } finally {
            setPortalLoading(false);
        }
    };

    if (loading) return <div className="sub-settings-container">Loading subscription details...</div>;

    return (
        <div className="sub-settings-container">
            <h2>Subscription & Billing</h2>
            <p className="sub-description">
                Manage your plan limitations, update payment methods, download invoices, or cancel your premium services.
            </p>

            <div className="current-plan-card">
                <div className="plan-info">
                    <span>Current Plan</span>
                    <h3 className="plan-badge">{userTier.toUpperCase()} PLAN</h3>
                </div>
                
                {userTier === 'free' ? (
                    <div className="plan-actions">
                        <p>Unlock features like increased card limits and deep analytics analytics.</p>
                        <button onClick={() => navigate('/pricing')} className="upgrade-btn">
                            Upgrade Plan
                        </button>
                    </div>
                ) : (
                    <div className="plan-actions">
                        <p>Your subscription is active. Click below to swap plans or terminate renewals.</p>
                        <button 
                            onClick={handleManageBilling} 
                            className="manage-billing-btn"
                            disabled={portalLoading}
                        >
                            {portalLoading ? 'Loading Portal...' : 'Manage Plan & Billing'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Subscriptions;